import { render } from "./what-intro.vue?vue&type=template&id=ba29beea&lang=pug"
import script from "./what-intro.vue?vue&type=script&lang=js"
export * from "./what-intro.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__